import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardBlockTitleComponent } from '../card-block-title/card-block-title.component';

@Component({
    selector: 'vw-card-block',
    imports: [CommonModule, CardBlockTitleComponent],
    templateUrl: './card-block.component.html',
    styleUrl: './card-block.component.scss'
})
export class CardBlockComponent {
  @Input() title?: string;
}
